import { render, staticRenderFns } from "./yuyveComment.vue?vue&type=template&id=196f9cf4&"
import script from "./yuyveComment.vue?vue&type=script&lang=ts&"
export * from "./yuyveComment.vue?vue&type=script&lang=ts&"
import style0 from "./yuyveComment.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports